<template>
  <div id="laureat" v-if="item" class="singleLaureat">
    <div class="laurMob">
      <div class="top">
        <div class="upper">

          <div class="prev" v-if="prev">
             <router-link :to="prev">&larr;</router-link>
          </div>

          <div class="title"><em><span v-html="item.title"></span></em>, <span v-html="item.domaine.title"></span></div>
          <div class="next" v-if="next">
             <router-link :to="next">&rarr;</router-link>
          </div>
          <div class="close">
            <router-link :to="'/' + backState" @click.native="closeEnter">
              <div class="closeInner">&times;</div>
            </router-link>
          </div>
        </div>

        <div class="lower">
          <span v-html="item.prix.title"></span>, <span v-html="item.year.title"></span>
        </div>
      </div>

      <div id="content">
        <div id="portrait" class="block" v-if="item.image.src" :class="{portrait: item.image.ratio > 100, landscape: item.image.ratio <= 100}">
          <div id="portraitInner" :style="{paddingBottom: item.image.ratio + '%'}" v-lazyload>
            <LazyImage :source="item.image.src" :blur="item.image.src_blur" />
          </div>
          <div v-if="item.image_credits" class="caption" v-html="item.image_credits"></div>
        </div>

        <div class="block">
          <span v-if="item.intro && !hidelaudatio" v-html="item.intro"></span>
          <span v-else><p></p></span>
        </div>

        <div id="video" v-if="item.video && !hidelaudatio" class="link">
          <Single :item="item"/>
        </div>

        <div id="tabs">
          <div v-for="tab in item.tabs" class="tab" :class="tab.title" :key="tab.title">
            <div class="tabTitle" v-html="tab.title"></div>
            <div class="tabText" v-html="tab.text"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Single from '@/components/SingleVideo.vue'
import LazyImage from '@/components/LazyImage.vue'

export default {
  data () {
    return {
      loaded: false
    }
  },

  components: {
    Single,
    LazyImage
  },

  props: ['index'],

  mounted () {
    this.$root.$emit('scrollAfterEnter')
  },

  methods: {
    closeEnter () {
      this.$parent.entered = false
    },

    adjLink (adj) {
      let rt
      if (this.$route.name === 'laureats-laureat') {
        rt = '/laureats/' + this.$route.params.filter + '/' + adj.year.title + '/' + adj.slug
      } else {
        rt = '/laureat/' + adj.year.title + '/' + adj.slug
      }

      return rt
    }
  },

  computed: {
    hidelaudatio () {
      let hL = this.$store.getters.hidelaudatio
      let cY = this.item.year.title === this.$store.state.currentyear

      if (hL === 1 && cY) {
        return true
      } else {
        return false
      }
    },

    backState () {
      let bS = this.$store.getters.backState
      let rS

      if (bS) {
        if (bS.page === 'current') {
          rS = 'laureats'
        } else if (bS.page === 'laureats') {
          rS = bS.page + '/' + bS.slug
        }
      } else {
        rS = 'laureats/annees'
      }

      return rS
    },

    item () {
      return this.$store.getters.laureat(this.$route.params.slug + this.$route.params.year)
    },

    currLoop () {
      return this.$store.getters.isCurrent
    },

    curri () {
      return this.$store.getters.curri(this.$route.params.slug + this.$route.params.year, this.currLoop)
    },

    next () {
      let adj = this.$store.getters.nexti(this.curri + 1, this.currLoop)

      if (adj) {
        return this.adjLink(adj)
      } else {
        return false
      }
    },

    prev () {
      let adj = this.$store.getters.nexti(this.curri - 1, this.currLoop)

      if (adj) {
        return this.adjLink(adj)
      } else {
        return false
      }
    }
  }
}
</script>
